angular.module('tgaAdmin').controller('AddDomainController', [
  '$scope',
  '$window',
  '$cookies',
  '$sce',
  '$filter',
  '$location',
  '$rootScope',
  '$q',
  'userService',
  'productService',
  'settingsService',
  'domainService',
  'stripe',
  'modalService',
  'supportService',
  'accountService',
  'orderService',
  '$log',
  'constants',
  '$translate',
  function (
    $scope,
    $window,
    $cookies,
    $sce,
    $filter,
    $location,
    $rootScope,
    $q,
    userService,
    productService,
    settingsService,
    domainService,
    stripe,
    modalService,
    supportService,
    accountService,
    orderService,
    $log,
    constants,
    $translate,
  ) {
    const redirectKey = 'tgaRedirect';

    $scope.data = {
      alerts: [],
      logo: '',
      defaultLogo: './v1/assets/images/logo-black.svg',
      products: [],
      plans: [],
      addons: [],
      subTotal: 0,
      totalTotal: 0,
      agreementText: null,
      available_groups: [],
      taxRate: 0,
      salesTax: 0,
      adminPrice: 499,
      playerPrice: 500,
      svcPlanPrice: 2500,
      screens: ['plans', 'purchase', 'address', 'billing', 'success'],
      screen: 'plans',
      avataxLoading: false,
      avataxError: '',
      countries: constants.countries,
      states: constants.states,
      showArcadesDetails: false,
    };

    $scope.viewmodel = {
      sso: null,
      token: null,
      domain: null,
      group_id: null,
      accepted_eula: null,
      agreement_id: null,
      admins: 0,
      players: 0,
      first_name: userService.getUserData().first_name,
      last_name: userService.getUserData().last_name,
      email: userService.getUserData().email,
      company: null,
      address: null,
      city: null,
      state: null,
      zip_code: null,
      country: 'US',
      phone: null,
      code: null,
      plan: null,
      games: [],
      products: [],
      addons: [],
      service_plan: false,
      tax: 0,
      transaction: {
        code: null,
        customerCode: null,
      },
      withArcades: false,
    };

    $scope.card = {
      number: null,
      expiry: null,
      cvc: null,
    };

    $scope.promo = {
      code: null,
      description: null,
      discount: null,
      final_price: null,
      type: null,
    };

    $scope.$watch('viewmodel.phone', (phone) => {
      $scope.viewmodel.phone = $filter('telephone')(phone);
    });

    $scope.initialize = function () {
      settingsService.getSettings().then((settings) => {
        $scope.data.logo = settings.logo || $scope.data.defaultLogo;
        $scope.data.adminPrice = settings.adminPrice ? settings.adminPrice : 499;
      });

      supportService.getAgreement().then((agreement) => {
        $scope.viewmodel.agreement_id = agreement.agreement_id;
        $scope.data.agreementText = agreement.text;
      });

      $scope.loading = true;
      $scope.loadingProducts = true;

      productService.getProducts().then((products) => {
        $scope.loading = false;
        $scope.loadingProducts = false;
        $scope.data.products = products.games;
        $scope.data.plans = products.bundles;
        $scope.data.addons = products.addons;

        $scope.data.plans.forEach((plan) => {
          plan.original_price = plan.price;
        });
        $scope.data.addons.forEach((addon) => {
          addon.original_price = addon.price;
        });
      });
    };

    $scope.actions = {
      toggleArcadesDetails() {
        const oldValue = $scope.data.showArcadesDetails;
        $scope.data.showArcadesDetails = !oldValue;
      },
      add1Admin() {
        $scope.viewmodel.admins += 1;
      },
      sub1Admin() {
        if ($scope.viewmodel.admins > 0) {
          $scope.viewmodel.admins -= 1;
        }
      },
      add500Players() {
        $scope.viewmodel.players += 1;
      },
      sub500Players() {
        if ($scope.viewmodel.players >= 1) {
          $scope.viewmodel.players -= 1;
        }
      },
      resetPromo() {
        $scope.data.alerts = [];

        $scope.promo = {
          code: null,
          description: null,
          discount: null,
          final_price: null,
          type: null, // 1 = percentage, 2 = fixed, 3 = trial, 4 = paid, 5 = partner
        };
      },
      checkCoupon() {
        $scope.loading = true;

        accountService
          .checkCoupon(
            $scope.viewmodel.code,
            $scope.viewmodel.plan.product_id,
            $scope.viewmodel.admins,
            $scope.viewmodel.players,
            $scope.viewmodel.service_plan,
          )
          .then(
            (response) => {
              $scope.loading = false;
              $scope.promo = response;

              if ($scope.promo.admins > 0) {
                $scope.viewmodel.admins = $scope.promo.admins;
              }

              if ($scope.promo.type === 3) {
                // trial
                $scope.showPrice = false;
              }

              $scope.actions.createAlert($translate.instant('common.activation_code_applied').toString(), 'success');
            },
            (err) => {
              $scope.loading = false;
              $scope.actions.createAlert(err.message, 'danger');
            },
          );
      },
      checkDomain() {
        $scope.actions.clearAlerts();

        if (!$scope.viewmodel.domain) {
          $scope.domain = null;
          return;
        }

        $scope.checkingDomain = true;

        domainService.checkDomain($scope.viewmodel.domain).then(
          (domain) => {
            $scope.domain = domain;

            if (domain.available === false) {
              $scope.addressForm.domain.$setValidity('required', false);
            }

            $scope.checkingDomain = false;
          },
          (err) => {
            $scope.domain = {
              available: false,
            };

            if (err.message) {
              $scope.domain.message = err.message;
            }

            $scope.addressForm.domain.$setValidity('required', false);

            $scope.checkingDomain = false;
          },
        );
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      clearAlerts() {
        $scope.data.alerts = [];
      },
      goToAdmin() {
        $scope.actions.redirect(userService.getUserData(), $scope.viewmodel.domain);
      },
      redirect(user, domain) {
        const expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 1);

        // If available groups is too long it breaks the cookie
        delete user.available_groups;

        $cookies.putObject(redirectKey, user, {
          path: '/',
          domain: `.${domainService.base}`,
          expires: expireDate,
        });

        $window.location.href = `${$window.location.protocol}//${domain}.${domainService.base}/admin/v1/login`;
      },
      presentEula() {
        const message = $scope.data.agreementText
          ? `<div class="subs-agreement">${$scope.data.agreementText}</div>`
          : 'Error loading agreement';

        modalService.showModal(
          {
            title: 'Terms and Conditions',
            message,
            closeButton: false,
          },
          {
            backdrop: true,
            keyboard: true,
            animation: true,
            size: 'lg',
          },
        );
      },
      subTotal() {
        let total = 0;

        if ($scope.viewmodel.plan) {
          total = $scope.viewmodel.plan.price;
        }

        if ($scope.viewmodel.admins > 0) {
          total += $scope.viewmodel.admins * $scope.data.adminPrice;
        }

        if ($scope.viewmodel.addons.length) {
          for (let i = 0; i < $scope.viewmodel.addons.length; i++) {
            total += $scope.viewmodel.addons[i].price;
          }
        }

        if ($scope.viewmodel.service_plan > 0) {
          total += $scope.viewmodel.service_plan * $scope.data.svcPlanPrice;
        }

        if ($scope.viewmodel.players > 0) {
          total += $scope.viewmodel.players * $scope.data.playerPrice;
        }

        return total;
      },
      totalTotal() {
        let total = $scope.actions.subTotal();

        // trial, paid and partner promo types are free
        if ($scope.promo.type === 3 || $scope.promo.type === 4 || $scope.promo.type === 5) {
          $scope.promo.discount = total;
        }

        if ($scope.promo.discount > 0) {
          total -= $scope.promo.discount;
        }

        $scope.viewmodel.tax = total * $scope.data.taxRate;

        total += $scope.viewmodel.tax;

        return total > 0 ? Math.round(total) : 0;
      },
      setPlan(plan) {
        if ($scope.data.plans.indexOf(plan) === -1) return;

        if ($scope.viewmodel.plan !== plan) {
          $scope.actions.resetPromo();
        }

        $scope.viewmodel.plan = plan;

        if ($scope.viewmodel.games.length > plan.max_games) {
          // more than max selected, reset to initial state
          $scope.viewmodel.games = [];
        }

        if (plan.bundle_type === 'full') {
          $scope.viewmodel.games = [];

          // // turn on all games.
          for (let i = 0; i < $scope.data.products.length; i++) {
            const game = $scope.data.products[i];
            $scope.viewmodel.games.push(game);
          }
        }

        if ($scope.viewmodel.plan.num_players < 1000) {
          $scope.viewmodel.players = 0;
        }

        $scope.actions.goToAddress();
      },
      chooseGame(game) {
        const index = $scope.viewmodel.games.indexOf(game);

        if (index > -1) {
          $scope.viewmodel.games.splice(index, 1);
        } else {
          $scope.viewmodel.games.push(game);
        }

        $log.log('game chosen: ', game, ' and viewmodel.chosenGames = ', $scope.viewmodel.games);
      },
      chooseAddon(addon) {
        const index = $scope.viewmodel.addons.indexOf(addon);

        if (index > -1) {
          $scope.viewmodel.addons.splice(index, 1);
        } else {
          $scope.viewmodel.addons.push(addon);
        }
      },
      toggleArcades() {
        if ($scope.viewmodel.withArcades) {
          $scope.data.addons.forEach((addon) => {
            if (addon.product_id === 22) {
              addon.price = 0;
              $scope.viewmodel.addons.push(addon);

              $scope.data.plans.forEach((plan) => {
                if (plan.num_players < 2500) {
                  plan.price += Math.floor(plan.price * 0.8);
                } else {
                  plan.price += addon.original_price;
                }
              });
            }
          });
        } else {
          $scope.viewmodel.addons = [];
          $scope.data.addons.forEach((addon) => {
            addon.price = addon.original_price;
          });
          $scope.data.plans.forEach((plan) => {
            plan.price = plan.original_price;
          });
        }
      },
      goToPlans() {
        $window.scrollTo(0, 0);
        $scope.data.screen = 'plans';
      },
      goToPurchase() {
        $scope.addressForm.submitted = true;

        if ($scope.addressForm.$invalid) {
          return;
        }

        const changeToPurchasePage = () => {
          $window.scrollTo(0, 0);
          $scope.data.screen = 'purchase';
        };

        // Try to post the transaction then return the data we get back.
        $scope.data.avataxLoading = true;
        $scope.data.avataxError = '';
        $scope.addressForm.state.$invalid = false;
        const transactionData = {
          ...$scope.viewmodel,
          final_price: $scope.promo.final_price,
          discount: $scope.promo.discount,
        };
        orderService.postTransaction(transactionData).then(
          (transaction) => {
            $scope.data.avataxLoading = false;
            // Parse the transaction JSON.
            transaction = angular.fromJson(transaction.data);
            // $log.log('order service sent viewmodel', transactionData, 'and got back a transaction:',  transaction);

            // Update the tax rate.
            $scope.data.taxRate = transaction.summary[0].rate || 0;

            // Save a copy of the relevant transaction fields.
            $scope.viewmodel.transaction = {
              code: transaction.code, // adjust the transaction with this code
              customerCode: transaction.customerCode, // and this customer code
            };

            changeToPurchasePage();
          },
          (err) => {
            $scope.data.avataxLoading = false;
            if (err && err.message) {
              if (err.message.indexOf("'region'") > -1) {
                err.message = err.message.replace("'region'", "'state'");
                $scope.addressForm.state.$invalid = true;
              } else if (err.message.indexOf('state') > -1 && err.message.indexOf('postal code') > -1) {
                err.message = err.message.replace("'postal code'", "'zip code'");
                $scope.addressForm.state.$invalid = true;
                $scope.addressForm.zip_code.$invalid = true;
              } else if (err.message.indexOf('ForceTimeout') > -1) {
                err.message = $translate.instant('common.sales_tax_error').toString();
              }

              $scope.data.avataxError = err.message;
            }
          },
        );
      },
      goToAddress() {
        $window.scrollTo(0, 0);
        $scope.data.screen = 'address';
      },
      goToBilling() {
        const changeToBillingPage = () => {
          $window.scrollTo(0, 0);
          $scope.data.screen = 'billing';
        };

        // Try to post the transaction then return the data we get back.
        const transactionData = {
          ...$scope.viewmodel,
          final_price: $scope.promo.final_price,
          discount: $scope.promo.discount,
        };
        $scope.data.avataxLoading = true;
        orderService.postTransaction(transactionData).then(
          (transaction) => {
            $scope.data.avataxLoading = false;
            // Parse the transaction JSON.
            transaction = angular.fromJson(transaction.data);
            // $log.log('order service sent viewmodel', transactionData, 'and got back a transaction:',  transaction);

            // Update the tax rate.
            $scope.data.taxRate = transaction.summary[0].rate || 0;

            // Save a copy of the relevant transaction fields.
            $scope.viewmodel.transaction = {
              code: transaction.code, // adjust the transaction with this code
              customerCode: transaction.customerCode, // and this customer code
            };

            changeToBillingPage();
          },
          (err) => {
            $scope.data.avataxLoading = false;
            $log.error(err);
          },
        );
      },
      goToSuccess() {
        $scope.paymentForm.submitted = true;
        $scope.actions.clearAlerts();

        if ($scope.paymentForm.$invalid) {
          return;
        }

        $scope.loading = true;

        const promises = [];

        // bypass stripe token if free trial
        if ($scope.promo.type !== 3 && $scope.promo.type !== 4 && $scope.promo.type !== 5) {
          const card = {
            number: $scope.card.number,
            exp_month: $scope.card.expiry.month,
            exp_year: $scope.card.expiry.year,
            cvc: $scope.card.cvc,
          };

          const token = stripe.card.createToken(card).then((response) => {
            $scope.viewmodel.token = response.id;
          });

          promises.push(token);
        }

        $q.all(promises)
          .then(() => userService.addDomain($scope.viewmodel))
          .then(() => {
            $window.scrollTo(0, 0);
            $scope.data.screen = 'success';
            return userService.getUser(userService.getUserData().id);
          })
          .then((user) => {
            userService.setUser(user);
            $rootScope.$broadcast('refreshDomains');

            const transactionData = {
              ...$scope.viewmodel,
              final_price: $scope.promo.final_price,
              discount: $scope.promo.discount,
            };
            // doesn't matter if this fails, we've already processed the transaction
            orderService.postCommit(transactionData);
          })
          .catch((err) => {
            $scope.actions.createAlert(err.message, 'danger');
          })
          .finally(() => {
            $scope.loading = false;
          });
      },
    };

    $scope.countryFieldUpdated = function (country) {
      $scope.viewmodel.state = country !== 'US' ? '--' : null;
    };

    $scope.initialize();
  },
]);
